<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <ReturnRecordForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ReturnRecordForm from '@/components/organisms/terminal/form/ReturnRecordForm'

export default {
  name: 'ReturnRecordPage',

  components: {
    ReturnRecordForm,
  },
}
</script>
